export default class WebGLCoordinate {

	public constructor (private x: number, private y: number) {}

	public getX () {
		return this.x;
	}

	public getY () {
		return this.y;
	}

	public getVerticesArray () {
		return [this.x, this.y];
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/WebGLCoordinate.ts